import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import './index.css';
import App from './App';

// import reportWebVitals from './reportWebVitals';
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {PersistQueryClientProvider} from '@tanstack/react-query-persist-client'
import {createAsyncStoragePersister} from '@tanstack/query-async-storage-persister'


const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 60 * 24, // 24h fresh
            gcTime: 1000 * 60 * 60 * 24 * 7, // keep 7 days
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
        },
    },
})

const persister = createAsyncStoragePersister({
    storage: window.localStorage,
})

const root = createRoot(document.getElementById('root')!);
root.render(
    <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{
            persister,
            buster: "",
            dehydrateOptions: {
                shouldDehydrateQuery: (query) => {
                    // Persist only successful queries
                    return query.state.status === "success";
                },
            }
        }}
    >
        <StrictMode>
            <App/>
        </StrictMode>
    </PersistQueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
